/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { Group, Scale } from '#utils/UNSAFE_visTypes/chart';

export const getLineAreaChartItemPosition = (
  seriesIndex: number,
  groupIndex: number,
  // TODO: JET-71332 ; should only be (number | undefined)[][]
  // scatter chart does not call this function
  renderedSeries: (number | undefined)[][] | (number[] | { x: number; y: number }[])[],
  getDataItem: (seriesIndex: number, groupIndex: number) => { x?: any } | undefined,
  groups: Group[],
  isHoriz: boolean,
  xScale: Scale,
  yScale: Scale,
  timeAxisType?: string
) => {
  // TODO: JET-71332; remove as number after JET-71332 is fixed
  const value = renderedSeries[seriesIndex][groupIndex] as number;
  if (value == null) {
    return undefined;
  }

  let xVal = groupIndex;
  if (timeAxisType) {
    const val =
      timeAxisType === 'mixedFrequency'
        ? getDataItem(seriesIndex, groupIndex)?.x
        : groups[groupIndex].id;
    xVal = new Date(val).getTime();
  }

  const x = isHoriz ? yScale.transform(value) : xScale.transform(xVal);
  const y = isHoriz ? xScale.transform(xVal) : yScale.transform(value);

  return { x, y, height: 0, width: 0 };
};
